module.exports = __webpack_public_path__ + "media/images/emblems/Ueberstorf-coat_of_arms-dea1b0c30006498fc876dd1d5886accd.svg";